import { Box, Typography } from "@mui/material"

export const Calendar = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%' }}>
            <Typography variant='h3' sx={{ fontSize: '1.5rem', fontWeight: 200, mt: 3, textAlign: 'center', }}>
                Calendar
            </Typography>
            <Box sx={{
                height: '90vh',
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-start',
                overflowX: 'auto',
                mt: 3,
            }}>
                <Box sx={{
                    height: '100%',
                    width: '100%',
                    minWidth: '500px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                }}>
                    <iframe
                        title="80s Calendar"
                        src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=America%2FChicago&src=ODAuY29uc2VydmF0aW9uLm1lbWJlcnNoaXBAZ21haWwuY29t&src=YWRkcmVzc2Jvb2sjY29udGFjdHNAZ3JvdXAudi5jYWxlbmRhci5nb29nbGUuY29t&src=ZW4udXNhI2hvbGlkYXlAZ3JvdXAudi5jYWxlbmRhci5nb29nbGUuY29t&color=%23039BE5&color=%2333B679&color=%230B8043" width="100%" height="100%" frameBorder="0" scrolling="no">
                    </iframe>
                </Box>
            </Box>
        </Box>
    )
}